/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatFdIcon16Light } from './FileFormatFdIcon16Light';
import { FileFormatFdIcon16Regular } from './FileFormatFdIcon16Regular';
import { FileFormatFdIcon16Solid } from './FileFormatFdIcon16Solid';
import { FileFormatFdIcon20Light } from './FileFormatFdIcon20Light';
import { FileFormatFdIcon20Regular } from './FileFormatFdIcon20Regular';
import { FileFormatFdIcon20Solid } from './FileFormatFdIcon20Solid';
import { FileFormatFdIcon24Regular } from './FileFormatFdIcon24Regular';
import { FileFormatFdIcon24Solid } from './FileFormatFdIcon24Solid';
import { FileFormatFdIcon32Regular } from './FileFormatFdIcon32Regular';
import { FileFormatFdIcon64Regular } from './FileFormatFdIcon64Regular';
var sizes = {
    16: {
        light: FileFormatFdIcon16Light,
        regular: FileFormatFdIcon16Regular,
        solid: FileFormatFdIcon16Solid,
    },
    20: {
        light: FileFormatFdIcon20Light,
        regular: FileFormatFdIcon20Regular,
        solid: FileFormatFdIcon20Solid,
    },
    24: {
        regular: FileFormatFdIcon24Regular,
        solid: FileFormatFdIcon24Solid,
    },
    32: {
        regular: FileFormatFdIcon32Regular,
    },
    64: {
        regular: FileFormatFdIcon64Regular,
    },
};
export var FileFormatFdIcon = forwardRef('FileFormatFdIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
